import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';
import { useState } from 'react';
import { Control, useForm } from 'react-hook-form';
import ControlledTextField from './controlled-text-field';
import { passwordRules } from './input-validation-rules';

function PasswordField({ control, ...fieldProps }: { control?: Control<any> } & TextFieldProps) {
  const { control: defaultControl } = useForm({ mode: 'onChange' });
  const [visiblePassword, setVisiblePassword] = useState(false);

  const togglePasswordVisibility = () => setVisiblePassword(!visiblePassword);

  return (
    <ControlledTextField
      control={control || defaultControl}
      controllerProps={{ rules: passwordRules }}
      fullWidth
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => togglePasswordVisibility()}
            >
              {visiblePassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      label="Password"
      name="password"
      {...fieldProps}
      clearable={false}
      type={visiblePassword ? 'text' : 'password'}
    />
  );
}

export default PasswordField;
